import {createBrowserRouter, RouteObject} from 'react-router';
import {authGuard} from '@common/auth/guards/auth-route';
import React from 'react';
import {RootErrorElement, RootRoute} from '@common/core/common-provider';
import {getBootstrapData} from '@ui/bootstrap-data/bootstrap-data-store';
import {authRoutes} from '@common/auth/auth-routes';
import {notificationRoutes} from '@common/notifications/notification-routes';
import {adminRoutes} from '@common/admin/routes/admin-routes';
import {checkoutRoutes} from '@common/billing/checkout/routes/checkout-routes';
import {billingPageRoutes} from '@common/billing/billing-page/routes/billing-page-routes';
import {commonRoutes} from '@common/core/common-routes';
import {siteRoutes} from '@app/routes/site-routes';
import {FullPageLoader} from '@ui/progress/full-page-loader';

// SSR (Konu 1): rota ağacı, createBrowserRouter'dan AYRI export edilir.
// Böylece Node SSR entry'si (server-entry.tsx) bu diziyi createStaticHandler'a
// besleyebilir. createBrowserRouter Node'da `document`e dokunduğu için ASLA
// sunucuda çağrılmamalı — appRouter aşağıda tarayıcıya guard'lanır.
export const routes: RouteObject[] = [
  {
    id: 'root',
    element: <RootRoute />,
    errorElement: <RootErrorElement />,
    hydrateFallbackElement: <FullPageLoader screen />,
    children: [
      ...authRoutes,
      ...notificationRoutes,
      ...adminRoutes,
      ...checkoutRoutes,
      ...billingPageRoutes,
      ...commonRoutes,
      ...siteRoutes,
      {
        path: 'api-dokumanlar',
        loader: () =>
          authGuard({permission: 'api.access', requireLogin: false}),
        lazy: () => import('@common/swagger/swagger-api-docs-page'),
      },
      {
        path: 'api-docs',
        loader: () =>
          authGuard({permission: 'api.access', requireLogin: false}),
        lazy: () => import('@common/swagger/swagger-api-docs-page'),
      },
    ],
  },
];

// Tarayıcıda gerçek data-router; Node'da null (SSR StaticRouterProvider kullanır).
export const appRouter =
  typeof document !== 'undefined'
    ? createBrowserRouter(routes, {
        basename: getBootstrapData().settings.html_base_uri,
      })
    : (null as unknown as ReturnType<typeof createBrowserRouter>);
